import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { FormikNumberField, FormikSwitch, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { StandardAlertInfo } from "../../../../../../shared/components/alert/StandardAlertInfo"
import { SelectDeviceTemplateDropdown } from "./SelectDeviceTemplateDropdown"
import { CreateDisplayFormValues, DisplayTypes } from "../deviceTypes"
import { SelectDeviceTypeDropdown } from "./SelectDeviceTypeDropdown"
import { DynamicRoomAutocomplete } from "./DynamicRoomAutocomplete"
import { useFormikContext } from "formik"
import { useMemo } from "react"
import { TranslationKey } from "../../../../../localization/translations"

type CreateUpdateDeviceFormProps = {
    isEditMode?: boolean
}

type TypeFieldInfo = { id: TranslationKey; title: string }

export const CreateUpdateDeviceForm = ({ isEditMode }: CreateUpdateDeviceFormProps) => {
    const { values } = useFormikContext<CreateDisplayFormValues>()
    const isMeetingDisplay = values.type == DisplayTypes.MEETING_DISPLAY

    const typeFieldInfo: TypeFieldInfo = useMemo(() => {
        if (values.type === DisplayTypes.MEETING_DISPLAY) {
            return {
                id: "devices-create-or-edit-form-type-meeting-details-info",
                title: "Meeting displays are typically put up on each floor and are designed to let people now where to go for their meeting.",
            }
        }

        return {
            id: "devices-create-or-edit-form-type-room-details-info",
            title: "Room displays are put up in front of meeting rooms to show if the room is currently available or occupied. It also offers a convenient way to book the room.",
        }
    }, [values.type])

    return (
        <>
            <StandardForm>
                <StandardMainPanel title="Access">
                    <SelectDeviceTypeDropdown isEditMode={isEditMode} />
                    <LocalizedStrict id={typeFieldInfo.id} attrs={{ title: true }}>
                        <StandardAlertInfo title={typeFieldInfo.id} />
                    </LocalizedStrict>
                </StandardMainPanel>
                <StandardMainPanel title="General">
                    {!isMeetingDisplay && <DynamicRoomAutocomplete />}
                    <LocalizedStrict
                        id="devices-create-or-edit-form-select-field-device-number"
                        attrs={{ label: true }}
                    >
                        <FormikTextField<CreateDisplayFormValues>
                            name="deviceNumber"
                            sx={{ width: "50%" }}
                            label="Device number"
                            fullWidth
                        />
                    </LocalizedStrict>
                    {isMeetingDisplay && (
                        <LocalizedStrict id="devices-create-or-edit-form-floor-label" attrs={{ label: true }}>
                            <FormikNumberField sx={{ width: "50%" }} name="floor" label="Floor" />
                        </LocalizedStrict>
                    )}
                    <LocalizedStrict id="devices-create-or-edit-form-select-field-name" attrs={{ label: true }}>
                        <FormikTextField<CreateDisplayFormValues> name="name" label="Name" fullWidth />
                    </LocalizedStrict>
                    <SelectDeviceTemplateDropdown />
                </StandardMainPanel>
                <LocalizedStrict id="merchant-delivery-location-form-settings" attrs={{ title: true }}>
                    <StandardSidePanel variant="collapsible" title="Settings">
                        <LocalizedStrict id="merchant-delivery-location-form-field-active">
                            <FormikSwitch<CreateDisplayFormValues> name="isActive">Active:</FormikSwitch>
                        </LocalizedStrict>
                        <LocalizedStrict
                            id="devices-create-or-edit-form-select-field-serial-number"
                            attrs={{ label: true }}
                        >
                            <FormikTextField<CreateDisplayFormValues>
                                name="serialNumber"
                                label="Serial number"
                                fullWidth
                            />
                        </LocalizedStrict>
                    </StandardSidePanel>
                </LocalizedStrict>
            </StandardForm>
        </>
    )
}
